import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		isMobile: false,
	},
	mutations: {
		setIsMobile(state, payload) {
			state.isMobile = payload
		}
	},
	actions: {

	}
})

export default store